<template>
    <div class="container page">
        <div class="header">
            <van-nav-bar :title="$t('sm')" class="nav-bar">
                <template #left>
                    <van-icon name="arrow-left" color="#fff" @click="back()" />
                </template>
            </van-nav-bar>
        </div>
        <div class="content">
            <div v-if="$i18n.locale == 'ja'" v-html="content"></div>
            <div v-if="$i18n.locale == 'ko'" v-html="content_ko"></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            content: `<h3><strong>会員認証制度についてのご案内</strong></h3>
                        <br>
                        本コミュニティでは、会員様同士が安心・安全にデートを楽しんでいただける環境を提供するため、三段階の会員認証制度を導入しております。<br><br>
                        これは、日本国内の婚活・マッチング文化に基づき、信頼性と安全性を最優先に考えた仕組みです。<br>
                        
                        <br>

                        <hr>
                        <br>
                         【第一回目の認証｜身分認証】

                        <p><strong>認証費用：9,500円</strong><br><br>
                        1.ご本人様確認のため、運転免許証・マイナンバーカード等の身分証明書を確認いたします。<br><br>
                        2.なりすましや虚偽登録を防止し、<strong>実在する誠実な会員様のみが活動できる環境</strong>を維持します。<br><br>
                        3.日本では「実名・実在確認」が信頼の基本とされており、安心して交流を始めるための必須ステップとなります。<br></p>
                        <br>

                        <hr>
                        <br>
                         【第二回目の認証｜経済認証】

                        <p><strong>認証費用：29,500円</strong><br><br>
                        1.交際時に発生し得る金銭トラブルを未然に防ぐため、安定した経済基盤の確認を行います。<br><br>
                        2.日本の恋愛・結婚文化において、<strong>経済的な安心感は重要な信頼要素</strong>と考えられています。<br><br>
                        3.経済認証を完了された方は、<strong>スポンサー付きデートや特別紹介制度の対象</strong>となります。<br></p>
                        <br>

                        <hr>
                        <br>
                         【第三回目の認証｜安全認証】

                        <p>本認証は、デート時の安全確保を目的とした最終認証です。<br></p>
                        <br>
                        女性会員様：<br><br>
                        ·&nbsp;人身安全保証金の支払いが必要です。<br>
                        
                        <br>
                        男性会員様：<br><br>
                        ·&nbsp;二段階認証の実施が必要です。<br><br>
                        ※ 本認証は 完了後、全額返金対象&nbsp;となります。<br>

                        <h3><strong>認証内容</strong></h3>
                        <p>1.デート前に、トラブル防止および安全対策の最終確認を行います。<br><br>
                        2.システム上の出金・返金機能を有効化し、デート中の金銭的・安全面でのリスクを回避します。<br><br>
                        3.本段階を完了すると、<strong>会員カードがアクティブ化され、正式なデートマッチングが可能</strong>となります。<br></p>
                        <br>

                        <hr>
                        <br>

                        <h3><strong>【ご注意】</strong></h3>
                        <p>安心・安全な出会いを実現するため、当社では <strong>三回の認証手続き</strong>&nbsp;を必須としております。<br><br>
                        これは、日本国内の婚活・マッチングサービスにおいて<strong>信頼性を重視した運営方針に基づく制度</strong>です。<br><br>
                        内容をご確認のうえ、ご理解いただけましたら、次のステップへご案内いたします。<br></p>
                        `,
            content_ko: `<h3><strong>회원 인증 제도 안내</strong></h3>
                            <br>
                            본 커뮤니티에서는 회원님들 간에 안심하고 안전하게 데이트를 즐기실 수 있는 환경을 제공하기 위해, 3단계 회원 인증 제도를 도입하고 있습니다.<br><br>
                            이는 일본의 결혼 및 매칭 문화에 기반하여, 신뢰성과 안전성을 최우선으로 고려한 시스템입니다.<br>

                            <br>

                            <hr>
                            <br>
                            【1차 인증｜신원 인증】

                            <p><strong>인증 비용：9,500엔</strong><br><br>
                            1. 본인 확인을 위해 운전면허증, 마이넘버 카드 등의 신분증을 확인합니다.<br><br>
                            2. 사칭 및 허위 등록을 방지하고, <strong>실존하는 성실한 회원만 활동할 수 있는 환경</strong>을 유지합니다.<br><br>
                            3. 일본에서는 “실명 및 실존 확인”이 신뢰의 기본으로 여겨지며, 안심하고 교류를 시작하기 위한 필수 단계입니다.<br></p>
                            <br>

                            <hr>
                            <br>
                            【2차 인증｜경제 인증】

                            <p><strong>인증 비용：29,500엔</strong><br><br>
                            1. 교제 시 발생할 수 있는 금전적 트러블을 사전에 방지하기 위해, 안정적인 경제 기반을 확인합니다.<br><br>
                            2. 일본의 연애 및 결혼 문화에서는 <strong>경제적 안정감이 중요한 신뢰 요소</strong>로 여겨집니다.<br><br>
                            3. 경제 인증을 완료하신 분은 <strong>스폰서 데이트 및 특별 소개 제도의 대상</strong>이 됩니다.<br></p>
                            <br>

                            <hr>
                            <br>
                            【3차 인증｜안전 인증】

                            <p>본 인증은 데이트 시 안전 확보를 위한 최종 인증입니다.<br></p>
                            <br>
                            여성 회원:<br><br>
                            ·&nbsp;신변 안전 보증금 납부가 필요합니다.<br>

                            <br>
                            남성 회원:<br><br>
                            ·&nbsp;2단계 인증 진행이 필요합니다.<br><br>
                            ※ 본 인증은 완료 후 전액 환불 대상입니다.<br>

                            <h3><strong>인증 내용</strong></h3>
                            <p>1. 데이트 전에 트러블 방지 및 안전 대책에 대한 최종 확인을 진행합니다.<br><br>
                            2. 시스템상의 출금 및 환불 기능을 활성화하여, 데이트 중 금전적·안전적 리스크를 회피합니다.<br><br>
                            3. 본 단계를 완료하면 <strong>회원 카드가 활성화되며, 정식 데이트 매칭이 가능</strong>해집니다.<br></p>
                            <br>

                            <hr>
                            <br>

                            <h3><strong>【유의사항】</strong></h3>
                            <p>안전하고 신뢰할 수 있는 만남을 위해 당사는 <strong>3단계 인증 절차</strong>를 필수로 하고 있습니다.<br><br>
                            이는 일본 내 결혼 및 매칭 서비스에서 <strong>신뢰성을 중시하는 운영 방침에 기반한 제도</strong>입니다.<br><br>
                            내용을 확인하신 후 이해해 주시면, 다음 단계로 안내해 드리겠습니다.<br></p>
                        `,
        };
    },
    methods: {
        back() {
            return window.history.back();
        },
    },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.container .content {
    height: calc(100% - 20px);
    overflow: auto;
    padding: 20px;
    background: #fff;
}
</style>
